/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Indemnification_Item_2Inputs */

const es_tyc_indemnification_item_2 = /** @type {(inputs: Tyc_Indemnification_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su violacion de cualquier ley aplicable o los derechos de un tercero.`)
};

const en_tyc_indemnification_item_2 = /** @type {(inputs: Tyc_Indemnification_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your violation of any applicable law or third-party rights.`)
};

/**
* | output |
* | --- |
* | "Your violation of any applicable law or third-party rights." |
*
* @param {Tyc_Indemnification_Item_2Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_indemnification_item_2 = /** @type {((inputs?: Tyc_Indemnification_Item_2Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Indemnification_Item_2Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_indemnification_item_2(inputs)
	return en_tyc_indemnification_item_2(inputs)
});
export { tyc_indemnification_item_2 as "tyc.indemnification.item_2" }